import React from 'react';
import SpreadReadingPage from './SpreadReadingPage';

const config = {
  pickerPage: 'love',
  path: '/love-tarot-reading/',
  spreadId: 'loveRelationships',
  cardCount: 3,
  tagline: 'Free Love Tarot Reading',
  metaTitle: 'Free Love Tarot Reading Online - Relationship Spread | NowTarot AI',
  metaDescription:
    'Get a free love tarot reading online. Draw 3 cards to explore your romantic past, present, and future. 100% free, no signup required.',
  metaKeywords:
    'love tarot reading, free love tarot, relationship tarot, love tarot spread, tarot reading for love, romance tarot',
  heading: 'Love Tarot Reading',
  blurb: 'Draw 3 cards for your love life.',
  intro:
    'Wondering where your heart is headed? This free love tarot reading uses a dedicated relationship spread: three cards revealing your romantic past, your current situation, and where your love life is going. 100% free, no signup required.',
  howItWorks:
    'Focus on your love life or a specific person, then shuffle the deck and pick three cards. The first card shows past romantic experiences still influencing you, the second reveals your present emotional situation, and the third points toward where your love life is heading.',
  deckHeading: 'Draw Your 3 Love Cards',
  contentSections: [
    {
      heading: 'What a Love Tarot Reading Can Reveal',
      items: [
        {
          title: 'If You Are in a Relationship',
          text: 'The cards can highlight the emotional currents between you and your partner — unspoken tensions, deepening bonds, or old wounds from past relationships that still shape how you love. Use the reading as a mirror for honest conversations.',
        },
        {
          title: 'If You Are Single',
          text: "A love reading can show what you're carrying from past romances, how open your heart is right now, and the energy surrounding new connections. Cards like the Ace of Cups or The Lovers often signal that new love is near.",
        },
        {
          title: 'If It Is Complicated',
          text: 'On-again off-again? Unclear signals? The past-present-future structure is ideal for untangling complicated situations, showing how you got here and which direction the relationship is moving.',
        },
      ],
    },
    {
      heading: 'Cards to Watch For in Love Readings',
      items: [
        {
          title: 'The Lovers & Two of Cups',
          text: 'The classic love cards. The Lovers speaks to deep alignment and meaningful choices in love, while the Two of Cups signals mutual attraction and a balanced, nurturing bond.',
        },
        {
          title: 'Three of Swords & Five of Cups',
          text: "These cards speak to heartbreak and grief. Drawing them doesn't doom your romance — they often surface pain that needs acknowledging before your love life can move forward.",
        },
        {
          title: 'The Empress & Knight of Cups',
          text: 'The Empress brings warm, nurturing, abundant love energy. The Knight of Cups is the romantic messenger — grand gestures, invitations, and following your heart.',
        },
      ],
    },
  ],
  faqHeading: 'Love Tarot FAQ',
  faq: [
    {
      question: 'How does a love tarot reading work?',
      answer:
        'You focus on your love life or a specific relationship, then draw three cards from the 78-card tarot deck. The cards represent your romantic past, present, and future, and each is interpreted through the lens of love and relationships.',
    },
    {
      question: 'Can tarot tell me if someone loves me?',
      answer:
        "Tarot reflects the emotional energies surrounding your situation. While no reading can read another person's mind, the cards can reveal the dynamics of the connection, how open both hearts are, and where the relationship is likely heading.",
    },
    {
      question: 'What questions should I ask in a love reading?',
      answer:
        'Open-ended questions work best: "What do I need to know about my relationship?", "What is blocking me from finding love?", or "Where is this connection heading?" For a quick yes-or-no answer, try our Yes or No tarot reading instead.',
    },
    {
      question: 'Is this love tarot reading free?',
      answer:
        'Yes! This love tarot reading is 100% free with no signup or credit card required. Draw as many readings as you like. For deeper, personalized guidance, ask our AI tarot reader in chat.',
    },
  ],
  crossLinks: (
    <>
      Want more? Ask a <a href="/yes-or-no-tarot/" style={{ color: '#FFD700' }}>yes or no tarot</a> question about your love life,
      explore <a href="/tarot-card-meanings/" style={{ color: '#FFD700' }}>tarot card meanings</a>, or go deep with
      the <a href="/celtic-cross-tarot/" style={{ color: '#FFD700' }}>10-card Celtic Cross</a> — all free, no signup required.
    </>
  ),
};

const LoveTarot = () => <SpreadReadingPage config={config} />;

export default LoveTarot;
